module.exports = __webpack_public_path__ + "static/media/logo1.911ed7f4.png";